import React, { useEffect, useState } from "react";
import apiClient from "../../lib/api";
import { useI18n } from "../../i18n";
import { toast } from "sonner";
import { Upload, Trash2, Copy } from "lucide-react";

const AdminMedia = () => {
  const { lang } = useI18n();
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => apiClient.get("/admin/media").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) {
        const fd = new FormData();
        fd.append("file", f);
        await apiClient.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } });
      }
      toast.success(`Uploaded ${files.length} ${files.length === 1 ? "file" : "files"}`);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  const remove = async (id) => {
    if (!window.confirm(lang === "nl" ? "Verwijderen?" : "Delete?")) return;
    await apiClient.delete(`/admin/media/${id}`);
    load();
  };

  const copy = (url) => {
    navigator.clipboard.writeText(url);
    toast.success("URL copied");
  };

  return (
    <div data-testid="admin-media-page">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-3">
        <h1 className="font-display text-4xl md:text-5xl tracking-tighter font-light">{lang === "nl" ? "Mediatheek" : "Media library"}</h1>
        <label className="btn-primary text-sm cursor-pointer" data-testid="media-upload-btn">
          <Upload className="w-4 h-4" /> {busy ? "…" : (lang === "nl" ? "Upload" : "Upload")}
          <input type="file" multiple accept="image/*" hidden onChange={upload} data-testid="media-upload-input" />
        </label>
      </div>
      <div className="text-xs text-ink-muted mb-4">{lang === "nl" ? "Max 4 MB per afbeelding. Ondersteund: jpg, png, webp." : "Max 4 MB per image. Supported: jpg, png, webp."}</div>

      {items.length === 0 ? (
        <div className="border border-dashed border-black/15 p-16 text-center text-ink-muted">{lang === "nl" ? "Nog geen media geüpload" : "No media uploaded yet"}</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {items.map((m) => (
            <div key={m.media_id} className="group relative bg-secondary-warm aspect-square overflow-hidden" data-testid={`media-tile-${m.media_id}`}>
              <img src={m.url} alt={m.filename} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100">
                <button onClick={() => copy(m.url)} className="w-9 h-9 bg-white text-ink flex items-center justify-center" title="Copy URL"><Copy className="w-4 h-4" /></button>
                <button onClick={() => remove(m.media_id)} className="w-9 h-9 bg-terracotta text-white flex items-center justify-center" title="Delete"><Trash2 className="w-4 h-4" /></button>
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-black/60 text-white text-[10px] px-2 py-1 truncate">{m.filename}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminMedia;
